import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth/auth.service';
import { routeAlias } from '../../routesalias'; // Assurez-vous que le chemin est correct

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router, private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add Authorization header from Keycloak in-memory token if available
        const token = this.authService.getToken();
        if (token) {
            try {
                const parsed = this.authService.getTokenParsed();
                const exp = parsed && parsed.exp ? new Date(parsed.exp * 1000).toISOString() : 'unknown';
                // Mask token start for safety in logs
                const masked = token ? `${token.substring(0, 10)}...` : 'no-token';
                //console.info('AuthInterceptor: attaching Authorization header. token present:', !!token, 'exp:', exp, 'token-start:', masked);
            } catch (e) {
                //console.info('AuthInterceptor: attaching Authorization header (token present)');
            }
        } else {
            console.info('AuthInterceptor: no token available when sending request to', request.url);
        }
        // Override applicationId on mutating requests with the trusted value from the token
        let trustedReq = request;
        try {
            const parsed = this.authService.getTokenParsed() as any;
            const tokenAppId = parsed?.app_id || '';
            const isMutating = request.method === 'POST' || request.method === 'PUT' || request.method === 'PATCH';
            const isPlainObjectBody = request.body && typeof request.body === 'object' && !(request.body instanceof FormData);

            if (isMutating && isPlainObjectBody) {
                const newBody = { ...request.body, applicationId: tokenAppId };
                trustedReq = request.clone({ body: newBody });
            }
        } catch (e) {
            // ignore
        }

        const authReq = token ? trustedReq.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : trustedReq;

        return next.handle(authReq).pipe(
            map((event: HttpEvent<any>) => {
                // Intercept successful HttpResponse bodies that contain a `data` array and
                // filter entries to only those belonging to the current user's app_id
                try {
                    if (event instanceof HttpResponse && event.body && Array.isArray(event.body.data)) {
                        const parsed = this.authService.getTokenParsed() as any;
                        const tokenAppId = parsed?.app_id || '';
                        const isRA = this.authService.hasAnyRole(['RA']);
                        if (!isRA && tokenAppId) {
                            const filtered = (event.body.data as any[]).filter(item => {
                                // If item has no applicationId, hide it (safer), else match
                                try {
                                    return !item.applicationId ? false : String(item.applicationId) === String(tokenAppId);
                                } catch (e) {
                                    return false;
                                }
                            });
                            const newBody = { ...event.body, data: filtered };
                            return event.clone({ body: newBody });
                        }
                    }
                } catch (e) {
                    // ignore filtering errors and return original event
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                // Only trigger login on 401 (Unauthorized). For 403 (Forbidden) the user is
                // authenticated but not allowed - do not force a Keycloak re-login which
                // often causes redirect loops. Let the UI handle the forbidden message.
                if (error.status === 401) {
                    console.error('Erreur 401 détectée. Tentative de relogin via Keycloak.');
                    try {
                        const key = 'kc-login-last-attempt';
                        const now = Date.now();
                        const cooldownMs = 30 * 1000; // 30 seconds
                        const last = parseInt(localStorage.getItem(key) || '0', 10) || 0;
                        if (now - last > cooldownMs) {
                            localStorage.setItem(key, String(now));
                            this.authService.login();
                        } else {
                            console.warn('Login déjà tenté récemment — ne pas relancer pour éviter boucle.');
                            const navKey = 'kc-login-last-nav';
                            const lastNav = parseInt(localStorage.getItem(navKey) || '0', 10) || 0;
                            const navCooldownMs = 60 * 1000; // 1 minute
                            if (now - lastNav > navCooldownMs) {
                                localStorage.setItem(navKey, String(now));
                                //this.router.navigate([routeAlias.login]);
                            }
                        }
                    } catch (e) {
                        //try { this.router.navigate([routeAlias.login]); } catch (_) {}
                    }
                } else if (error.status === 403) {
                    // Forbidden: don't try to re-login; log and let the UI surface the error.
                    console.warn('Erreur 403 reçue. L’utilisateur est authentifié mais l’accès est refusé.');
                }
                // Rethrow the error
                return throwError(() => error);
            })
        );
    }
}